import messages from './exchange-rate-afir-form-lang.json';
import VueFocus from 'vue-focus';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import date from '../../../common/js/validators/date';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import datePicker from '../../../common/components/date-picker/date-picker.js';
import selectBox from '../../../common/components/select-box/select-box.vue';

import VueSelect from '../../../common/components/vue-select/vue-select.vue';
import { VueSelectOption } from '@ui-common/vue-select';
import VueDatepicker from '@ui-common/vue-datepicker';
import VueErrorMessage from '@ui-common/vue-error-message';

export default {
	data() {
		return {
			version: null,
			date: null,
			foreignType: null,
			focusedTab: null
		};
	},
	i18n: { messages },
	validations() {
		return {
			date: {
				required,
				date: date(BACKEND_DATE_FORMAT)
			}
		};
	},
	mixins: [VueFocus.mixin],
	props: {
		'version-info': {
			required: true
		}
	},
	components: {
		'date-picker': datePicker,
		'select-box': selectBox,
		VueSelect,
		VueSelectOption,
		VueDatepicker,
		VueErrorMessage
	},
	computed: {
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		disabledSelect() {
			return this.versionInfo.versions.length <= 1;
		}
	},
	watch: {
		version() {
			this.changeVersion();
		},
		versionInfo(val) {
			if (val && val.versions && val.versions.length) {
				this.version = val.versions[0].version;
				this.date = val.date;
				this.changeVersion();
			}
		}
	},
	methods: {
		uuid() {
			return window.crypto.randomUUID();
		},
		changeVersion() {
			let filteredVersions = this.versionInfo.versions.filter((version) => {
				return version.version == this.version;
			});
			if (filteredVersions.length) {
				this.$emit('on-version-change', filteredVersions[0]);
			}
		},
		getRates() {
			this.$v.$touch();
			if (this.date && !this.$v.date.$invalid) {
				this.$emit('on-date-change', this.date);
			}
		},
		getTimeLabel(version) {
			let timeLabel;
			if (this.$i18n.locale == 'hu') {
				timeLabel = version.time + ' (' + version.version + ')';
			} else {
				timeLabel = moment(version.time, 'HH:mm').format('hh:mm A') + ' (' + version.version + ')';
			}
			return timeLabel;
		},
		closePopup() {
			this.$refs.download.focus();
		}
	},
	created() {
		this.date = moment().format(BACKEND_DATE_FORMAT);
		this.foreignType = 'standard';
	}
};
